export const stateList = [
  { label: 'AK' },
  { label: 'AL' },
  { label: 'AR' },
  { label: 'AZ' },
  { label: 'CA' },
  { label: 'CO' },
  { label: 'CT' },
  { label: 'DE' },
  { label: 'FL' },
  { label: 'GA' },
  { label: 'HI' },
  { label: 'IA' },
  { label: 'ID' },
  { label: 'IL' },
  { label: 'IN' },
  { label: 'KS' },
  { label: 'KY' },
  { label: 'LA' },
  { label: 'MA' },
  { label: 'MD' },
  { label: 'ME' },
  { label: 'MI' },
  { label: 'MN' },
  { label: 'MO' },
  { label: 'MS' },
  { label: 'MT' },
  { label: 'NC' },
  { label: 'ND' },
  { label: 'NE' },
  { label: 'NV' },
  { label: 'NH' },
  { label: 'NJ' },
  { label: 'NM' },
  { label: 'NY' },
  { label: 'OH' },
  { label: 'OK' },
  { label: 'OR' },
  { label: 'PA' },
  { label: 'RI' },
  { label: 'SC' },
  { label: 'SD' },
  { label: 'TN' },
  { label: 'TX' },
  { label: 'UT' },
  { label: 'VA' },
  { label: 'VT' },
  { label: 'WA' },
  { label: 'WI' },
  { label: 'WV' },
  { label: 'WY' },
];
